// Fullscreen button.
export function initFullscreen() {
	const toggle = () => {
		if (!document.fullscreenElement) {
			(document.documentElement.requestFullscreen || (() => {})).call(document.documentElement);
		} else if (document.exitFullscreen) {
			document.exitFullscreen();
		}
	};

	document.querySelectorAll('[data-fullscreen-toggle]').forEach((btn) => btn.addEventListener('click', toggle));
}
